var React = require('react');

function LinkArrows (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.373 20.454L.627 17.546l7.46-7.046-7.46-7.046L3.373.546l10.54 9.954-10.54 9.954z","fill":"#FFD850","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.373 20.454l-2.746-2.908 7.46-7.046-7.46-7.046L12.373.546l10.54 9.954-10.54 9.954z","fill":"#FFD850","key":1})]);
}

LinkArrows.defaultProps = {"viewBox":"0 0 23 20","fill":"none"};

module.exports = LinkArrows;

LinkArrows.default = LinkArrows;
